import React, { useEffect, useState, useRef } from 'react';
import '../About/About.css';
import { Link } from 'react-router-dom';
import {
  FaCheck,
  FaGem,
  FaLayerGroup,
  FaUsers,
  FaBolt,
  FaChartLine,
  FaHeadset,
  FaFileInvoiceDollar,
  FaThumbsUp,
  FaSmile,
} from 'react-icons/fa';
import image from '../../Assets/about/about sec.png';
import qualityImage from '../../Assets/about/quality-section.png';

const StatCard = ({ icon, target, text, index }) => {
  const [count, setCount] = useState(0);
  const [visible, setVisible] = useState(false);
  const cardRef = useRef(null);

  // Reveal + start counting only once the card scrolls into view
  useEffect(() => {
    const el = cardRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.4 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!visible) return;

    let start = 0;
    const end = parseInt(target);
    if (start === end) return;

    const totalDuration = 2000;
    const incrementTime = (totalDuration / end) * 0.9;

    const timer = setInterval(() => {
      start += 1;
      setCount(start);
      if (start === end) clearInterval(timer);
    }, incrementTime);

    return () => clearInterval(timer);
  }, [visible, target]);

  let symbol = '';
  if (text === 'Recommended' || text === 'Satisfaction') {
    symbol = '%';
  } else if (text === 'Tax Services') {
    symbol = '+';
  }

  return (
    <div
      className={`stat-card${visible ? ' is-visible' : ''}`}
      ref={cardRef}
      style={{ transitionDelay: `${(index || 0) * 120}ms` }}
    >
      <div className="stat-icon-ring">
        {icon}
      </div>
      <h2>{count}{symbol}</h2>
      <p>{text}</p>
    </div>
  );
};

const chooseItems = [
  { code: 'Q/R', icon: <FaGem />, title: 'Quality & Reliability', desc: 'Choose us for quality and reliability, in every engagement.' },
  { code: 'E2E', icon: <FaLayerGroup />, title: 'End-to-End Solutions', desc: 'We offer the best end-to-end solution for your business.' },
  { code: 'C/F', icon: <FaUsers />, title: 'Client-Focused', desc: 'We understand client needs at the operational and enterprise level.' },
  { code: 'F/F', icon: <FaBolt />, title: 'Fast & Friendly', desc: 'Fast, convenient, and friendly service, every time.' },
  { code: 'B/G', icon: <FaChartLine />, title: 'Business Growth', desc: 'Our strong business focus improves your bottom-line.' },
  { code: 'O/S', icon: <FaHeadset />, title: 'Ongoing Support', desc: 'We provide ongoing advice and instant support.' },
];

const About = () => {
  return (
    <div>

      <div className="about-us d-flex justify-content-around" >
        <div className='about-txt' data-aos="flip-up">
          <p className='heading1'>Oriental Business Solutions Inc.</p>
          <h1>Why Oriental Business Solutions ?</h1>
          <p className='description'>
            Our customers are significant to us, and we have a very cordial relationship focusing on access, speed, reliability, professionalism, and expertise. Our quality service, competitive pricing, and prompt responsiveness in process outsourcing ensures the growth and development of our clients with utmost satisfaction for us.
          </p>
          <p className='description'>
            We guarantee that each client gets the close to assessment and consideration they deserve.
          </p>
          <Link to='/about' className="read-more">About Us</Link>
        </div>
        <div className='about-img'>
          <div className="about-img-frame">
            <img src={image} data-aos="fade-left" alt="Tax Services" />
            <div className="about-badge">
              <span className="about-badge-icon"><FaCheck /></span>
              <div className="about-badge-text">
                <strong>100%</strong>
                <span>Client Satisfaction</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="about-section-block about-quality" data-aos="fade-up">
        <div className="about-section-inner about-quality-inner">
          <div className="about-quality-text">
            <p className='heading1'>Quality</p>
            <h1>Quality is Important</h1>
            <p className='description'>
              Quality is something which is on top of our mind. In a business like ours, quality is when we have a satisfied client. Our customers have consistently been happy with our delivery and the testimony given by them proves our stand.</p>
            <p className='description'>
              In Oriental Business Solutions, we have developed proprietary software to measure accuracy in our process.
            </p>
            <p className='description'>
              To safeguard our customers' information, we use the most advanced internet security technology. Our dedicated network is secure with limited access facilities including comprehensive security systems, dedicated and isolated data-communication lines and well-planned contingency procedures.
            </p>
          </div>
          <div className="about-quality-media" data-aos="fade-left">
            <img src={qualityImage} alt="Quality standards at Oriental Business Solutions" />
          </div>
        </div>
      </section>

      <section className="about-section-block about-choose" data-aos="fade-up">
        <div className="about-section-inner choose-inner">
          <p className='heading1'>Choose Us</p>
          <h1>Why should you Choose Us?</h1>
          <p className='description'>
            We are cost-effective and consistently deliver high quality output based on our client needs.
          </p>

          <div className="choose-ledger">
            {chooseItems.map((item, i) => (
              <div
                className="choose-ledger-row"
                key={item.title}
                data-aos="fade-up"
                data-aos-delay={i * 60}
              >
                <span className="choose-ledger-code">{item.code}</span>
                <span className="choose-ledger-icon">{item.icon}</span>
                <div className="choose-ledger-copy">
                  <h4>{item.title}</h4>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <p className='description'>
            We are one of the most professional accounting firms in GTA, offering a full range of services. We pride ourselves on developing trusted relationships with our clients, and we understand the importance of responding to client queries in a timely and thorough manner. With our hands-on approach, we will work with you to help you achieve your goals.
          </p>
        </div>
      </section>

      <div className="stats-container">
        <div className="stats-row">
          <StatCard icon={<FaFileInvoiceDollar />} target="172" text="Tax Services" index={0} />
          <StatCard icon={<FaThumbsUp />} target="97" text="Recommended" index={1} />
          <StatCard icon={<FaSmile />} target="100" text="Satisfaction" index={2} />
          {/* <StatCard icon={<FaAward />} target="46" text="International Awards" /> */}
        </div>
      </div>
    </div>
  );
};

export default About;